export default "__VITE_ASSET__Dh8k074j__"